import React from 'react';
import PropTypes from 'prop-types';
import EducationCategoryIcons from '@components/atoms/education/icons-category/educationIconsCategory';
import Headline from '@components/atoms/headline/headline';
import Link from 'next/link';
import CloseIcon from '@components/icons/close.svg';
import Image from 'next/image';
import track from '@helper/tracking';
import StyledEducationCategoryCard from './educationCategoryCard.style';

const EducationCategoryCard = ({
  category,
  slug,
  title,
  index,
  filter = false,
  setTopicFiltering,
  topicFiltering
}) => {
  const toggleFilter = filterValue => {
    if (topicFiltering === filterValue) {
      setTopicFiltering(''); // Toggle off the filter if it's already active
    } else {
      setTopicFiltering(filterValue); // Toggle on the filter if it's not active
    }
  };

  const isFilterActive = !!(filter && topicFiltering === category);

  return (
    <StyledEducationCategoryCard
      index={index + 1}
      category={category}
      isFilterActive={isFilterActive}
    >
      <div className="category-card">
        <div className="category-card__content">
          <EducationCategoryIcons className="category-card__icon" category={category} />
          {filter ? (
            <button
              type="button"
              onClick={() => {
                toggleFilter(`${category}`);
                track(['trackEvent', 'bildungCategory', 'Click', category]);
              }}
            >
              {title && <Headline className="category-card__title">{title}</Headline>}
              <span className="category-card__stretched-link" />
            </button>
          ) : (
            <Link href={slug && `/de/bildung/bibliothek?topicFilter=${slug}`}>
              {title && <Headline className="category-card__title">{title}</Headline>}
              <span className="category-card__stretched-link" />
            </Link>
          )}
        </div>
        <div className="category-card__dots">
          <div className="category-card__dots-container">
            <Image
              layout="fill"
              objectPosition="center"
              objectFit="contain"
              src="/static/education/dots/topicTeaser.svg"
            />
          </div>
        </div>
      </div>
      {isFilterActive && (
        <div className="category-card__filter">
          <div className="category-card__filter-icon">
            <CloseIcon height="18" width="18" />
          </div>
          <button type="button" onClick={() => toggleFilter(`${category}`)}>
            {title && <Headline className="category-card__filter-title">{title}</Headline>}
            <span className="category-card__stretched-link" />
          </button>
        </div>
      )}
    </StyledEducationCategoryCard>
  );
};

EducationCategoryCard.propTypes = {
  category: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  filter: PropTypes.bool,
  setTopicFiltering: PropTypes.func,
  topicFiltering: PropTypes.string
};

export default EducationCategoryCard;
